export default class Permissions
{
    public static Studio = class
    {
        public static Modules = class
        {
            public static Access = 'Ideo.Core.Common.Application.Permissions.Studio.ModulesPermissions@Access';
            public static Edit = 'Ideo.Core.Common.Application.Permissions.Studio.ModulesPermissions@Edit';
            public static Delete = 'Ideo.Core.Common.Application.Permissions.Studio.ModulesPermissions@Delete';
        };

        public static Endpoints = class
        {
            public static Access = 'Ideo.Core.Common.Application.Permissions.Studio.EndpointsPermissions@Access';
            public static Edit = 'Ideo.Core.Common.Application.Permissions.Studio.EndpointsPermissions@Edit';
            public static Delete = 'Ideo.Core.Common.Application.Permissions.Studio.EndpointsPermissions@Delete';
        };
    };
};
